import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import "./styles.css";
import ModalAlert from "../../common/modal-alert";
import ModalConfirm from "../../common/modal-confirm";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { CompanyStatus } from "../../../services/constants";

class Company extends Component {
  state = {
    load: false,
    errors: {},
    states: {},
    dataCompany: {},
    CompanyStatus: null,
    CompanyStatusUpdate: null,
    CompanyStatusId: false,
    isActiveCompany: false,
    CompanyType: null,
    loadCreate: false,
    CompanyId: null,
    sectors: {},
    sectorsSelected: [],
    SectorId: null,
    businessUnit: "",
    businessUnits: []
  };

  async componentDidMount() {
    this.searchDataCompany();
    this.searchCompanyTypes();
    this.searchCompanyStatus();
    this.searchSectors();
    this.states();
    this.loadBusinessUnits();
  }

  loadBusinessUnits = () => {
    try {
        const businessUnitsStr = process.env.REACT_APP_BUSINESS_UNITS || '[]';
        const businessUnits = JSON.parse(businessUnitsStr);
        this.setState({ businessUnits });
    } catch (error) {
        console.error("Error parsing business units:", error);
        this.setState({ businessUnits: [] });
    }
  }

  searchCompanyTypes = async () => {
    this.setState({ load: true });
    const response = await api.get("/company-types");
    this.setState({ companyTypes: response.data.rows, load: false });
  };

  searchCompanyStatus = async () => {
    this.setState({ load: true });
    const response = await api.get("/company-status");
    this.setState({ CompanyStatuses: response.data.rows, load: false });
  };

  states = () => {
    let stat = [
      { nome: "Acre", sigla: "AC" },
      { nome: "Alagoas", sigla: "AL" },
      { nome: "Amapá", sigla: "AP" },
      { nome: "Amazonas", sigla: "AM" },
      { nome: "Bahia", sigla: "BA" },
      { nome: "Ceará", sigla: "CE" },
      { nome: "Distrito Federal", sigla: "DF" },
      { nome: "Espírito Santo", sigla: "ES" },
      { nome: "Goiás", sigla: "GO" },
      { nome: "Maranhão", sigla: "MA" },
      { nome: "Mato Grosso", sigla: "MT" },
      { nome: "Mato Grosso do Sul", sigla: "MS" },
      { nome: "Minas Gerais", sigla: "MG" },
      { nome: "Pará", sigla: "PA" },
      { nome: "Paraíba", sigla: "PB" },
      { nome: "Paraná", sigla: "PR" },
      { nome: "Pernambuco", sigla: "PE" },
      { nome: "Piauí", sigla: "PI" },
      { nome: "Rio de Janeiro", sigla: "RJ" },
      { nome: "Rio Grande do Norte", sigla: "RN" },
      { nome: "Rio Grande do Sul", sigla: "RS" },
      { nome: "Rondônia", sigla: "RO" },
      { nome: "Roraima", sigla: "RR" },
      { nome: "Santa Catarina", sigla: "SC" },
      { nome: "São Paulo", sigla: "SP" },
      { nome: "Sergipe", sigla: "SE" },
      { nome: "Tocantins", sigla: "TO" }
    ];
    this.setState({ states: stat });
  };

  searchDataCompany = async () => {
    api
      // .get(`/companies?cnpj=${this.props.match.params.cnpj}`) //DEPRECATED
      .get(`/companies?id=${this.props.match.params.id}`)
      .then(response => {
        if (response.data.rows.length) {
          this.setState({
            dataCompany: response.data.rows[0],
            CompanyStatus: response.data.rows[0].CompanyStatus.description,
            CompanyStatusId: response.data.rows[0].CompanyStatus.id,
            CompanyStatusUpdate: response.data.rows[0].CompanyStatus.id,
            isActiveCompany:
              response.data.rows[0].CompanyStatus.description !==
              CompanyStatus.Desativado.name
                ? true
                : false,
            CompanyType: response.data.rows[0].CompanyType.id,
            CompanyId: response.data.rows[0].id,
            businessUnit: response.data.rows[0].businessUnit || ""
          });

          document.getElementById("socialName").value =
            response.data.rows[0].socialName;
          document.getElementById("inscricaoEstadual").value =
            response.data.rows[0].inscricaoEstadual;
          document.getElementById("businessName").value =
            response.data.rows[0].businessName;
          document.getElementById("cep").value = response.data.rows[0].cep;
          document.getElementById("country").value =
            response.data.rows[0].country;
          document.getElementById("state").value = response.data.rows[0].state;
          document.getElementById("city").value = response.data.rows[0].city;
          document.getElementById("district").value =
            response.data.rows[0].district;
          document.getElementById("address").value =
            response.data.rows[0].address;
          document.getElementById("number").value =
            response.data.rows[0].number;
          document.getElementById("objectOfContract").value =
            response.data.rows[0].objectOfContract;
          
          // We'll set the value of businessUnit in the dropdown after it's loaded
          setTimeout(() => {
            if (document.getElementById("businessUnit")) {
              document.getElementById("businessUnit").value =
                response.data.rows[0].businessUnit || "";
            }
          }, 100);

          this.searchCompanySectors();
          console.log(
            "TCL: Company -> searchDataCompany -> response.data.rows",
            response.data.rows
          );
        }
      })
      .catch(error => {
        let errors = error.response.data.errors;
        this.setState({
          errors,
          msgErro:
            "Não foi possível cadastrar os contatos para a empresa! Tente novamente.",
          loadCreate: false
        });
      });
  };

  verifyValidation = id => {
    if (this.state.errors && this.state.errors.length > 0) {
      let dados = this.state.errors.filter(item => {
        return item.param == id;
      });
      if (dados.length) {
        return dados[0].msg;
      } else {
        return false;
      }
    }
  };

  setNextStatus = async (CompanyStatusId) => {
    const {
      CompanyId,
      isActiveCompany,
    } = this.state;
    const enabledStatus = [1, 2, 3, 4, 5];
    const isSameStatus = enabledStatus.some(elem => elem == CompanyStatusId);
    if (!isActiveCompany) {
      await api
        .delete(`/companies/${CompanyId}/deletesector/`)
        .then(result => {
          this.setState({ sectorsSelected: [] });
        })
        .catch(err => {
          this.setState({ errors: err.response.data.errors });
        });
      return CompanyStatus.Desativado.id;
    } else if (isActiveCompany && isSameStatus) {
      return CompanyStatusId;
    } else {
      return CompanyStatus.SolicitacaoDeCadastro.id;
    }
  };

  alterCompany = async () => {


    this.setState({ msgErro: null, loadCreate: true});

    let CompanyStatusIdCur = (this.state.CompanyStatusUpdate !== '') ? this.state.CompanyStatusUpdate : this.state.CompanyStatusId;

    let CompanyStatusId = await this.setNextStatus(CompanyStatusIdCur);

    let CompanyTypeText = this.state.CompanyType;
    let cnpj = this.state.dataCompany.cnpj;
    let phone = this.state.dataCompany.phone;
    let CompanyTypeId = this.state.CompanyType;
    let socialName = document.getElementById("socialName").value;
    let businessName = document.getElementById("businessName").value;
    let objectOfContract = document.getElementById("objectOfContract").value;
    let address = document.getElementById("address").value;
    let number = document.getElementById("number").value;
    let city = document.getElementById("city").value;
    let state = document.getElementById("state").value;
    let district = document.getElementById("district").value;
    let country = document.getElementById("country").value;
    let cep = this.transform(document.getElementById("cep").value);
    let inscricaoEstadual = document.getElementById("inscricaoEstadual").value;
    inscricaoEstadual = !inscricaoEstadual ? null : inscricaoEstadual;
    let businessUnit = document.getElementById("businessUnit").value;

    if (CompanyTypeText == "Estrangeiro" && (cep == "" || !cep)) {
      cep = "00000000";
    }
    if (CompanyTypeText == "Estrangeiro" && (state == "" || !state)) {
      state = "NA";
    }
    if (CompanyTypeText == "Estrangeiro" && (city == "" || !city)) {
      city = "N/A";
    }
    if (CompanyTypeText == "Estrangeiro" && (district == "" || !district)) {
      district = "N/A";
    }
    if (CompanyTypeText == "Estrangeiro" && (address == "" || !address)) {
      address = "N/A";
    }
    if (CompanyTypeText == "Estrangeiro" && (number == "" || !number)) {
      number = "00";
    }

    await api
      .put(`/companies/${this.state.CompanyId}`, {
        CompanyStatusId,
        cnpj,
        phone,
        CompanyTypeId,
        socialName,
        businessName,
        address,
        number,
        city,
        state,
        district,
        country,
        cep,
        inscricaoEstadual,
        objectOfContract,
        businessUnit
      })
      .then(result => {
        this.setState({ loadCreate: false });
        document.getElementById("modal-alert").click();
        this.setState({ msgAlert: result.data.msg, classText: "text-success" });
      })
      .catch(error => {
        let errors = error.response.data.errors || [];
        
        // Create an error message with all details
        let errorMessage = "Não foi possível cadastrar a empresa! Tente novamente.";
        
        if (errors && errors.length > 0) {
          // Add error messages as a list
          errorMessage += " Detalhes: \n" + errors.map(err => `- ${err.msg}`).join("\n");
        }
        
        this.setState({
          errors,
          msgErro: errorMessage,
          loadCreate: false
        });
      });
  };

  searchSectors = async () => {
    this.setState({ load: true });
    const response = await api.get(`/sectors?status=1`);
    this.setState({ sectors: response.data.rows, load: false });
  };

  searchCompanySectors = async () => {
    this.setState({ load: true });
    const { CompanyId } = this.state;
    const response = await api.get(`/companies/${CompanyId}/sectors`);
    const ids = response.data.map(item => item.SectorId);
    this.setState({ sectorsSelected: ids, load: false });
  };

  selectSector = e => {
    this.setState({ SectorId: e.target.value });
  };

  filterSector = id => {
    return this.state.sectors.filter(item => item.id === parseInt(id))[0].name;
  };

  addSector = async () => {
    const { SectorId, CompanyId } = this.state;
    if (this.state.sectorsSelected.indexOf(SectorId) == -1 && SectorId) {
      this.setState({
        sectorsSelected: [...this.state.sectorsSelected, SectorId]
      });
      const response = await api.post(`/companies/sectors`, {
        SectorId,
        CompanyId
      });
    }
  };

  removeSector = async e => {
    const { CompanyId } = this.state;
    const newSectors = this.state.sectorsSelected.filter(
      item => parseInt(item) !== parseInt(e.target.id)
    );
    this.setState({ sectorsSelected: newSectors });
    const response = await api.delete(
      `/companies/${CompanyId}/deletesector/${e.target.id}`
    );
  };

  transform = string => {
    var novo = string.replace(/[\-()._/]/g, "");
    return novo;
  };

  redirectSuccess = () => {
    window.location.href = "/solicitations";
  };

  handleStatus = async () => {
    this.setState({
      isActiveCompany: !this.state.isActiveCompany
    });
  };

  render() {
    return (
      <Fragment>
        <div className="row page-titles">
          <div className="col-md-5 col-8 align-self-center">
            <h3 className="text-themecolor">
              Editar Empresa
              {this.state.load ? (
                <i className="fa fa-spin fa-spinner"></i>
              ) : null}
            </h3>
          </div>
        </div>

        {this.state.msgErro && (
          <div className="alert alert-danger">
            <div>{this.state.msgErro.split("\n").map((item, key) => {
              return <p key={key}>{item}</p>
            })}</div>
          </div>
        )}

        <div className="row">
          <div className="p-b-10">
            <a
              href="../../solicitations"
              className="btn btn-rounded btn-outline-primary"
            >
              <i className="mdi mdi-arrow-left"></i>
            </a>
          </div>

          <div className="col-md-12 alert alert-primary">
            <span>
              Status da empresa:
              <strong> {this.state.CompanyStatus}</strong>
            </span>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <h5>CNPJ</h5>
              <span>
                {this.state.dataCompany.cnpj
                  ? this.state.dataCompany.cnpj
                  : null}
              </span>
            </div>
          </div>
          
          <div className="col-md-3">
            <div className="form-group">
              <h5>Unidade de Negócio</h5>
              <select 
                id="businessUnit" 
                className="custom-select col-12"
              >
                <option value="">Selecione</option>
                {
                  this.state.businessUnits.map((unit, index) => (
                    <option key={index} value={unit}>{unit}</option>
                  ))
                }
              </select>
              <i className="message-error">
                {this.verifyValidation("businessUnit")}
              </i>
            </div>
          </div>
          
          <div className="col-md-4">
            
            <h5>Status da empresa</h5>
            <select
              id="companyStatuses"
              className="custom-select col-12"
              value={this.state.CompanyStatusUpdate}
              onChange={e => this.setState({ CompanyStatusUpdate: e.target.value })}
            >
              <option>Selecione</option>
              {this.state.CompanyStatuses
                ? this.state.CompanyStatuses.map(item => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.description}
                      </option>
                    );
                  })
                : null}
            </select>
            <i className="message-error">
              {this.verifyValidation("companyStatuses")}
            </i>
          </div>
          
          
          
          <div className="col-md-4">
            <h5>Tipo de empresa</h5>
            <select
              id="companyTypes"
              className="custom-select col-12"
              value={this.state.CompanyType}
              onChange={e => this.setState({ CompanyType: e.target.value })}
            >
              <option></option>
              {this.state.companyTypes
                ? this.state.companyTypes.map(item => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.description}
                      </option>
                    );
                  })
                : null}
            </select>
            <i className="message-error">
              {this.verifyValidation("companyTypes")}
            </i>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <h5>Razão Social</h5>
              <input type="text" id="socialName" className="form-control" />
              <i className="message-error">
                {this.verifyValidation("socialName")}
              </i>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <h5>Inscrição Estadual</h5>
              <input
                type="text"
                id="inscricaoEstadual"
                className="form-control"
              />
              <i className="message-error">
                {this.verifyValidation("inscricaoEstadual")}
              </i>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <h5>Nome Fantasia</h5>
              <input type="text" id="businessName" className="form-control" />
              <i className="message-error">
                {this.verifyValidation("businessName")}
              </i>
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <h5>CEP</h5>
              <input
                type="text"
                id="cep"
                data-mask="99.999-999"
                className="form-control"
              />
              <i className="message-error">{this.verifyValidation("cep")}</i>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <h5>País</h5>
              <input type="text" id="country" className="form-control" />
              <i className="message-error">
                {this.verifyValidation("country")}
              </i>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <h5>UF</h5>
              <select id="state" className="custom-select col-12">
                <option></option>
                {this.state.states.length
                  ? this.state.states.map(item => {
                      return <option key={item.sigla}>{item.sigla}</option>;
                    })
                  : null}
              </select>
              <i className="message-error">{this.verifyValidation("state")}</i>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <h5>Cidade</h5>
              <input type="text" id="city" className="form-control" />
              <i className="message-error">{this.verifyValidation("city")}</i>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <h5>Bairro</h5>
              <input type="text" id="district" className="form-control" />
              <i className="message-error">
                {this.verifyValidation("district")}
              </i>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <h5>Endereço</h5>
              <input type="text" id="address" className="form-control" />
              <i className="message-error">
                {this.verifyValidation("address")}
              </i>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <h5>Número</h5>
              <input type="number" id="number" className="form-control" />
              <i className="message-error">{this.verifyValidation("number")}</i>
            </div>
          </div>
          <div className="col-md-10">
            <div className="form-group">
              <h5>Objeto de Contrato</h5>
              <input
                type="text"
                id="objectOfContract"
                className="form-control"
              />
              <i className="message-error">
                {this.verifyValidation("objectOfContract")}
              </i>
            </div>
          </div>
          <div className="col-md-6">
            <h5>Adicionar Área Gestora:</h5>
            <div className="input-group">
              <select
                className="form-control custom-select col-md-12"
                onChange={this.selectSector}
              >
                <option value="">Todas</option>
                {this.state.sectors.length
                  ? this.state.sectors.map((item, index) => {
                      return (
                        <option key={index} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })
                  : null}
              </select>

              <span class="input-group-btn">
                <button class="btn btn-info" onClick={this.addSector}>
                  <i class="fa fa-plus"></i>
                  Adicionar
                </button>
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <h5>Áreas Gestoras Vinculadas:</h5>

              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">
                      <b>#</b>
                    </th>
                    <th scope="col">
                      <b>Nome</b>
                    </th>
                    <th align="right">
                      <b>Ações</b>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.sectorsSelected.length ? (
                    this.state.sectorsSelected.map((item, index) => {
                      return (
                        <tr key={index}>
                          <th>{item}</th>
                          <th>{this.filterSector(item)}</th>
                          <th align="right">
                            <button
                              class="btn btn-icon btn-sm btn-danger"
                              id={item}
                              onClick={this.removeSector}
                              title="Remover Área gestora"
                            >
                              <i class="fa fa-2x fa-times" id={item}></i>
                            </button>
                          </th>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <th colspan="3" align="center">
                        Nenhum registro!
                      </th>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 text-right">
            <div className="form-actions">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.isActiveCompany}
                    onChange={this.handleStatus}
                    color="primary"
                    value={this.state.isActiveCompany}
                  />
                }
                label={this.state.isActiveCompany ? "Ativo" : "Desativado"}
              />
              {this.state.loadCreate ? (
                <i className="fa fa-spin fa-spinner"></i>
              ) : null}
              <button
                disabled={this.state.loadCreate}
                onClick={this.alterCompany}
                className="btn btn-success"
              >
                {" "}
                <i className="fa fa-edit"></i> Alterar
              </button>
            </div>
          </div>
        </div>

        <ModalConfirm
          title="Confirmação"
          msg="Tem certeza que deseja alterar os dados da empresa?"
          function={this.alterStatusEmployee}
          msgError={this.state.erroDelete}
        />
        <ModalAlert
          title="Empresa"
          msg={this.state.msgAlert}
          function={this.redirectSuccess}
          classText={this.state.classText}
        />
      </Fragment>
    );
  }
}

export default Company;
